import { useI18n } from "@/i18n";

export default function BotApp() {
  const { lang } = useI18n();
  const onLoad = (e) => {
    // Push the chosen language into the bot page as soon as it boots
    // (the bot also reads localStorage jobky.lang and listens for messages).
    try {
      e.currentTarget.contentWindow.postMessage({ type: "jobky-lang", lang }, "*");
    } catch (err) {}
  };
  return (
    <div className="h-screen w-full overflow-hidden" style={{ background: "#eef1f5" }} data-testid="bot-app">
      <iframe
        src="/api/bot"
        title="Jobky app"
        className="h-full w-full border-0"
        allow="clipboard-write; downloads"
        onLoad={onLoad}
        data-testid="bot-iframe"
      />
    </div>
  );
}
